import { PluginSimple } from 'markdown-it';
import { baseKeymap } from 'prosemirror-commands';
import { InputRule } from 'prosemirror-inputrules';
import { ParseSpec } from 'prosemirror-markdown';
import { MarkSpec, NodeSpec } from 'prosemirror-model';
import { Plugin } from 'prosemirror-state';

import { EditorOptions, extensionType, PerformanceType } from '../ExtensionManager/types';

export default abstract class BaseExtension {
  // prosemirror !!
  get schema(): NodeSpec | MarkSpec | null {
    return null;
  }

  // prosemirror !!
  abstract get name(): string;

  // prosemirror !!
  get keys(): typeof baseKeymap | null {
    return null;
  }

  // prosemirror !!
  inputRules(_editorOptions: EditorOptions): InputRule[] {
    return [];
  }

  get type(): string {
    return extensionType.node;
  }

  get performanceType(): PerformanceType {
    return PerformanceType.SCROLL_BASED;
  }

  plugins(_editorOptions: EditorOptions): Plugin[] {
    return [];
  }

  get rulePlugins(): PluginSimple[] {
    return [];
  }

  parseMarkdown(): ParseSpec | void {
    return undefined;
  }

  get markdownToken(): string | null {
    return null;
  }
}
